import { Box, BoxProps } from "@mui/material";

export function AppBox(props: BoxProps) {
    return (
        <Box mb={2} columnGap={2} {...props}>
            {props.children}
        </Box>)
}